import type { RouteRecordRaw } from "vue-router";

// Public, unauthenticated, read-only certificate viewer (QR target).

/**
 * The printed QR opens the viewer at `/verify/#/vc/{token}`: a path of its own
 * because nginx never sees the fragment, and `/verify/` is the one path
 * shariyah.net may frame. Frozen once printed.
 */
const VERIFY_PATH = "/verify/";
const VIEWER_ROUTES: ReadonlySet<unknown> = new Set([
  "PublicCertificate",
  "PublicGuideline",
  "PublicCertificateSearch",
]);

/**
 * True when a navigation must be refused: on the framable page, only the
 * viewer may render, so a framed page never shows sign-in or the portal.
 */
export function refusedOnVerifyPage(
  pathname: string,
  routeName: unknown,
): boolean {
  return pathname.startsWith(VERIFY_PATH) && !VIEWER_ROUTES.has(routeName);
}

export const publicCertificateRoutes: RouteRecordRaw[] = [
  {
    path: "/search",
    name: "PublicCertificateSearch",
    component: () =>
      import("@/views/PublicCertificate/CertificateSearchView.vue"),
  },
  {
    path: "/vc/:token",
    name: "PublicCertificate",
    component: () =>
      import("@/views/PublicCertificate/PublicCertificateDetailsView.vue"),
    props: true,
  },
  {
    path: "/vc/:token/guideline",
    name: "PublicGuideline",
    component: () =>
      import("@/views/PublicCertificate/PublicCertificateView.vue"),
    props: true,
  },
];
